import { PUBLICATION_STATUS } from 'constants/constants';

/**
 * Builds UI-ready summary from publication output rows (API or activity payload).
 *
 * @param {Array|undefined|null} publicationOutputRows
 * @param {'pearsonPlusStatus' | 'oculusStatus'} statusFieldKey
 * @returns {{ marketsExist: boolean, markets: Array<{ marketName: string, marketStatus: * }>, currentStatus: * }}
 */
export function getPublicationOutputSummary(publicationOutputRows, statusFieldKey) {
  const emptySummary = {
    marketsExist: false,
    markets: [],
    currentStatus: null,
  };

  if (!Array.isArray(publicationOutputRows) || publicationOutputRows.length === 0) {
    return emptySummary;
  }

  const readStatus = (row) => row?.[statusFieldKey];

  const marketsExist = publicationOutputRows.some(
    (row) => row?.publicationOutputType?.split(':')?.length > 1,
  );

  const markets = [];
  if (marketsExist) {
    publicationOutputRows.forEach((row) => {
      markets.push({
        marketName: row.publicationOutputType?.split(':')[1] ?? '',
        marketStatus: readStatus(row),
      });
    });
  }

  const publishedLiveRowIndex = publicationOutputRows.findIndex(
    (row) => readStatus(row) === PUBLICATION_STATUS.PUBLISHED_LIVE,
  );
  const representativeRowIndex =
    publishedLiveRowIndex === -1 ? 0 : publishedLiveRowIndex;
  const currentStatus = readStatus(publicationOutputRows[representativeRowIndex]);

  return {
    marketsExist,
    markets,
    currentStatus,
  };
}
